import PropTypes from 'prop-types';
import { useState } from 'react';
import ReactModal from 'react-modal';

import CUSTOM_STYLES from '../utils/modalStyle';

import { PrimaryButton } from './Buttons/Buttons';
import styles from './GenericModalV2.module.scss';

const CUSTOM_STYLES_V2 = {
  overlay: {
    ...CUSTOM_STYLES.overlay,
  },
  content: {
    ...CUSTOM_STYLES.content,
    outline: '0',
  },
};

function GenericModalV2({
  children,
  isOpen = true,
  mainText = '',
  modalLabel,
  onClickContinue,
  submitText = 'Συνέχεια',
}) {
  const [_isModalOpen, setIsModalOpen] = useState(isOpen);
  const _onClickContinue = onClickContinue || closeModal;

  function closeModal() {
    setIsModalOpen(false);
  }

  return (
    <ReactModal
      isOpen={_isModalOpen}
      style={CUSTOM_STYLES_V2}
      contentLabel={modalLabel}
      ariaHideApp={false}
      className={styles.modalContent}
    >
      <div className={styles.modalContainer}>
        <main>{children || <p className={styles.text}>{mainText}</p>}</main>

        <footer>
          <PrimaryButton onClick={_onClickContinue}> {submitText}</PrimaryButton>
        </footer>
      </div>
    </ReactModal>
  );
}

GenericModalV2.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  mainText: PropTypes.string,
  modalLabel: PropTypes.string.isRequired,
  onClickContinue: PropTypes.func,
};

export default GenericModalV2;
